import debug from "debug";

const log = debug("DateHelper");

class DateHelper {
	constructor() {}

	LocaleDKTimeFormat = {
		hourCycle: "h24",
		hour: "2-digit",
		minute: "2-digit",
	};

	LocaleDKDateFormat = {
		weekday: "long",
		day: "2-digit",
		month: "2-digit",
		year: "numeric",
	};

	/**
	 * Adding minutes to a given dateTime string
	 *
	 * @param {number} minutes
	 * @param {Object} `new Date()` object with given dateTime string
	 * @param {boolean} toLocaleDKTime
	 * @param {boolean} toInteger
	 * @returns {string || number}
	 */
	AddMinutes(minutes, date = new Date(), toLocaleDKTime, toInteger) {
		date.setMinutes(date.getMinutes() + minutes);

		if (toLocaleDKTime)
			return date.toLocaleTimeString("da-DK", {
				hourCycle: "h24",
				hour: "2-digit",
				minute: "2-digit",
			});

		if (!toLocaleDKTime) return date;

		if (toInteger) return parseInt(date);
	}

	/**
	 * Check how many days before from a dateTime string
	 *
	 * @param {string} dateTimeStr given dateTime string
	 * @param {number} days number of days
	 * @returns {boolean}
	 */
	CheckDaysBeforeStartDateTime(dateTimeStr, days) {
		const daysBeforeStartDateTime = new Date(
			new Date(dateTimeStr) - days * 24 * 60 * 60 * 1000
		);

		return daysBeforeStartDateTime <= new Date();
	}

	/**
	 * Check how many minutes after a given dateTime string
	 *
	 * @param {string} dateTimeStr given dateTime string
	 * @param {number} minutes n minutes
	 * @returns {boolean}
	 */
	CheckMinutesAfterStartDateTime = (dateTimeStr, minutes) => {
		return (
			this.AddMinutes(minutes, new Date(dateTimeStr), false, true) >
			new Date().getTime()
		);
	};

	/**
	 * Check how many days before from a dateTime string
	 *
	 * @param {string} dateTimeStr given dateTime string
	 * @param {string} localeDateTimeStr given local dateTime string
	 * @param {number} minutes n minutes
	 * @returns {boolean}
	 */
	CheckMinutesBeforeStartDateTime(dateTimeStr, localeDateTimeStr, minutes) {
		const isSameDay =
			localeDateTimeStr ===
			new Date().toLocaleDateString("da-DK", this.LocaleDKTimeFormat);

		if (isSameDay) {
			return (
				this.AddMinutes(minutes, new Date(), false, true) >= // add 30' to currentTime
				new Date(dateTimeStr).getTime()
			);
		} else {
			return false;
		}
	}

	/**
	 * Convert timestamp to month.day string
	 *
	 * @param {string} data Timestamp
	 * @returns {string} Date in the format 'month.day'
	 */
	Format(timestamp) {
		if (!timestamp) {
			log("No timestamp given!");
			return "Missing date";
		}

		let date = new Date(timestamp);
		let day = date.getDate();
		let month = date.getMonth() + 1;

		return `${day <= 9 ? "0" + day : day}.${month <= 9 ? "0" + month : month}`;
	}

	/**
	 * Substract minutes from a given dateTime string
	 *
	 * @param {number} minutes
	 * @param {date} `new Date()` object with dateTime string
	 * @param {boolean} toLocaleDKTime
	 * @param {boolean} toInteger
	 *
	 * @returns {string || number}
	 */
	SubtractMinutes = (minutes, date = new Date(), toLocaleDKTime, toInteger) => {
		date.setMinutes(date.getMinutes() - minutes);

		if (toLocaleDKTime)
			return date.toLocaleTimeString("da-DK", {
				hourCycle: "h24",
				hour: "2-digit",
				minute: "2-digit",
			});

		if (!toLocaleDKTime) return date;
		if (toInteger) return parseInt(date);
	};
}

export default DateHelper;
